module.exports = __webpack_public_path__ + "static/media/chat05.ed8adf3f.svg";